// extracted by mini-css-extract-plugin
module.exports = {"root":"M63RichTextWithBackground_root__F3VLR","media":"M63RichTextWithBackground_media__cCyKq"};